export default __webpack_public_path__ + "static/media/2.628e2398.jpg";